
import { useUserStore } from '@/store/user'
import { watchEffect } from 'vue'



const displayTypeMap = new Map()
// const disableAllEvent = (event) => {
//     event.stopImmediatePropagation()
//     event.stopPropagation();
//     event.preventDefault()
// }

const removeEl = (el, binding) => {
    if (binding.arg === 'disabled') {
        if (!el.parentNode) {
            return
        }
        // 防止嵌套设置
        if (el.parentNode.className === 'permission-item') return

        const style = window.getComputedStyle(el)
        // 与原来位置有关的style需要同步
        let styleCopy = `display: ${style.display};`
        if (style.marginTop) styleCopy += `margin-top: ${style.marginTop};`
        if (style.marginBottom) styleCopy += `margin-bottom: ${style.marginBottom};`
        if (style.marginLeft) styleCopy += `margin-left: ${style.marginLeft};`
        if (style.marginRight) styleCopy += `margin-right: ${style.marginRight};`
        
        // 增加容器dom
        const wrapHTML = `<div class="permission-item" style="${styleCopy}"><div class="permission-mask" tooltip="没有权限" effect="light" placement="top"></div>${el.outerHTML}</div>`

        // 更新el
        el.outerHTML = wrapHTML
    } else {
        el.style.display = 'none'
    }
}

const addEl = (el, binding) => {
    // console.log('@ ~ file: permission.js:42 ~ addEl ~ el, binding:', el, binding)
    // 替换掉给自己占位的注释节点
    // const parent = el._parentNode || el.parentNode
    // el.parentNode?.replaceChild(el, el._placeholderNode)
    if (binding.arg === 'disabled') {
        // el.classList.remove('is-disabled')
        // el.disabled = false
        // el.setAttribute('aria-disabled', false)
        // el.removeEventListener('click', disableAllEvent)
    } else {
        const displayType = displayTypeMap.get(el)
        el.style.display = displayType
    }
}

const hasPermission = val => {
    const userStore = useUserStore()
    return userStore.allAuthorities.includes(val)
}


const checkPermission = (el, binding) => {
    let update = () => {
        try {
            if (hasPermission(binding.value)) {
                addEl(el, binding)
            } else {
                removeEl(el, binding)
            }
        } catch (error) {
            console.log(error);
        }

    };
    if (el._watchEffect) {
        update()
    } else {
        el._watchEffect = watchEffect(() => {
            update()
        })
    }
}
// 导出一个对象用作自定义指令的第二个参数
const directive = {
    mounted(el, binding) {
        // console.log('@ ~ file: permission.js:99 ~ mounted ~ :', el, binding)
        displayTypeMap.set(el, el.style.display)
        checkPermission(el, binding)
    },
    updated(el, binding) {
        // console.log('@ ~ file: permission.js:104 ~ updated ~ :', el, binding)
        checkPermission(el, binding)
    },
}
export default directive